import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('urban-typing-indicator')
export class TypingIndicator extends LitElement {
  static override styles = css`
    :host {
      display: inline-flex;
      gap: 4px;
      align-items: center;
      padding: 10px 14px;
      background: var(--urban-bg-soft, #1a1a1a);
      border: 1px solid var(--urban-border, #E5E7EB);
      border-radius: 14px;
      border-bottom-left-radius: 4px;
      margin: 6px 0;
      align-self: flex-start;
    }
    span {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: var(--urban-accent, #8FFE09);
      animation: bounce 1.2s infinite;
    }
    span:nth-child(2) { animation-delay: 0.15s; }
    span:nth-child(3) { animation-delay: 0.3s; }
    @keyframes bounce {
      0%, 60%, 100% { transform: translateY(0); opacity: 0.45; }
      30% { transform: translateY(-4px); opacity: 1; }
    }
  `;

  override render() {
    return html`<span></span><span></span><span></span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'urban-typing-indicator': TypingIndicator;
  }
}
